export const ADD_LINK = 'ADD_LINK';
export const DELETE_LINK = 'DELETE_LINK';
export const PLAY_VIDEO = 'PLAY_VIDEO';
export const CANCEL_VIDEO = 'CANCEL_VIDEO';
export const LOAD_ITEMS = 'LOAD_ITEMS';
export const SEARCH_ITEMS = 'SEARCH_ITEMS';
export const CLOSE_SEARCH = 'CLOSE_SEARCH';
